import { render, staticRenderFns } from "./S202.vue?vue&type=template&id=185dcb1e&scoped=true"
import script from "./S202.vue?vue&type=script&lang=js"
export * from "./S202.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=185dcb1e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185dcb1e",
  null
  
)

export default component.exports